import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import { UpdateConfigVersionState } from '../action/config-version.action';
import { initialConfigVersionState } from '../state/config-version.state';

const configVersionReducer = createReducer(
  initialConfigVersionState,

  on(UpdateConfigVersionState, (state: any, { payload }) => ({ ...state, ...payload })),

);

export function ConfigVersionReducer(state: any, action: Action) {
  return configVersionReducer(state, action);
}
